import { useEffect } from 'react';
import { toast } from 'react-toastify';

import toastConfig from '../components/shared/constants/toaster-config';
import { consumeSedeLostNotice } from '../utils/partnerAccess/sedeSession';

// What the user reads after a sede was left for them. Never a code, an id or
// a token: the reason only picks the sentence.
const BACK_TO_ACCOUNT = 'Saliste de la sede y volviste a tu cuenta.';
const ACCESS_ENDED = 'Tu acceso a la sede terminó. Elígela de nuevo desde tu perfil.';
const TEMPORARY_OUTAGE = 'No pudimos conectar con la sede. Inténtalo de nuevo en unos minutos.';

const MESSAGE_BY_REASON = {
  NOT_A_PARTNER: 'Tu usuario ya no tiene acceso de socio. Volviste a tu cuenta.',
  FEATURE_DISABLED: 'El acceso a sedes está desactivado por ahora. Volviste a tu cuenta.',
  SEDE_NOT_IN_GROUP: 'Esa sede ya no forma parte de tu grupo. Volviste a tu cuenta.',
  SESSION_EXPIRED: ACCESS_ENDED,
  UNAUTHENTICATED: ACCESS_ENDED,
  UNAVAILABLE: TEMPORARY_OUTAGE,
  NETWORK: TEMPORARY_OUTAGE,
  RATE_LIMITED: TEMPORARY_OUTAGE,
  LOGOUT_FAILED: 'No se pudo cerrar la sesión. Inténtalo de nuevo.',
};

/**
 * Tells the user, once, why the tab is no longer the sede it was (the notice
 * is left by `partnerAccess/sedeSession` before it reloads into the normal
 * session). Without a notice it does nothing.
 */
const useSedeLostNotice = () => {
  useEffect(() => {
    const reason = consumeSedeLostNotice();
    if (reason === null) return;
    const message = Object.prototype.hasOwnProperty.call(MESSAGE_BY_REASON, reason)
      ? MESSAGE_BY_REASON[reason]
      : BACK_TO_ACCOUNT;
    toast.info(message, toastConfig);
  }, []);
};

export default useSedeLostNotice;
